"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// loads moment-timezone's timezone data, which comes from the
// IANA Time Zone Database at https://www.iana.org/time-zones
_momentTimezone.default.tz.load({
  version: 'latest',
  zones: [],
  links: []
});

var tzNames = function () {
  //  We want to subset the existing timezone data as much as possible, both for efficiency
  //  and to avoid confusing the user. Here, we focus on removing redundant timezone names
  //  and timezone names for timezones we don't necessarily care about, like Antarctica, and
  //  special timezone names that exist for convenience.
  var scrubbedPrefixes = ['Antarctica', 'Arctic', 'Chile'];
  var scrubbedSuffixes = ['ACT', 'East', 'Knox_IN', 'LHI', 'North', 'NSW', 'South', 'West'];

  var getZoneName = function getZoneName(zone) {
    return typeof zone === 'string' ? zone.split('|')[0] : zone.name;
  };

  var onlyCanonicalZones = function onlyCanonicalZones(zone) {
    return zone.indexOf('/') >= 0;
  };

  var nonBlacklistedPrefixes = function nonBlacklistedPrefixes(zone) {
    return !(scrubbedPrefixes.indexOf(zone.split('/')[0]) >= 0);
  };

  var nonBlacklistedSuffixes = function nonBlacklistedSuffixes(zone) {
    return !(scrubbedSuffixes.indexOf(zone.split('/').slice(-1)[0]) >= 0);
  }; // Filter using _zones in this manner in order to reduce the number of duplicated and deprecated timezone names
  // until moment-timezone provides a better way: https://github.com/moment/moment-timezone/issues/227


  return Object.values(_momentTimezone.default.tz._zones) // eslint-disable-line no-underscore-dangle
  .map(getZoneName).filter(function (zone) {
    return onlyCanonicalZones(zone) && nonBlacklistedPrefixes(zone) && nonBlacklistedSuffixes(zone);
  });
}(); // We need a human-friendly city name for each timezone identifier
// counting Canada/*, Mexico/*, and US/* allows users to search for
// things like 'Eastern' or 'Mountain' and get matches back


var tzCities = tzNames.map(function (name) {
  return ['Canada', 'Mexico', 'US'].indexOf(name.split('/')[0]) >= 0 ? name : name.split('/').slice(-1)[0];
}).map(function (name) {
  return name.replace(/_/g, ' ');
}); // Provide a mapping between a human-friendly city name and its corresponding
// timezone identifier and timezone abbreviation as a named export.
// We can fuzzy match on any of these.

var interimTzSet = new Set();
tzCities.forEach(function (city, index) {
  var tzMap = {};
  var tzName = tzNames[index];
  tzMap.city = city;
  tzMap.zoneName = tzName;
  tzMap.zoneAbbr = (0, _momentTimezone.default)().tz(tzName).zoneAbbr();
  interimTzSet.add(tzMap);
}); // the interimTzSet is just used for the purpose of eliminating duplicates

var tzMaps = _toConsumableArray(interimTzSet);

var _default = tzMaps;
exports.default = _default;